const handleMainUser = (state = {}, action) => {
    switch (action.type) {
      case 'SET_MAINUSER':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleMainUser;